// @flow
import {WIZARD} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {StickyType} from './stickyType';

const initialState = {
    isEnabled: false,
};

/**
 * Reducer for sticky on pdp
 * @param {ReadersPowerOptionsType} state Current state
 * @param {ActionType<AxiosPromise>} action Received action
 * @returns {ReadersPowerOptionsType} state New state
 */
export default function stickyPDPreducer(
    state: StickyType = initialState,
    action: ActionType<boolean>,
): StickyType {
    switch (action.type) {
        case WIZARD.TOGGLE_STICKY:
            return {isEnabled: action.payload};
        default:
            return state;
    }
}
